import { NavItem } from "../nav-item/nav-item";

export const navItems: NavItem[] = [
  {
    navCap: 'Menú',
  },
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    bgcolor: 'primary',
    route: '/store',
  },
  {
    displayName: 'Contactos',
    iconName: 'address-book',
    bgcolor: 'primary',
    route: '/store/contactos',
  },
  
];
